import {DestroyRef, inject, Injectable, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FEATURE_FLAG_SERVICE} from '@shared/domain/tokens/feature-flag.token';
import {PaymentFlag} from '../../domain/model/payment-flags.enum';
import {PaymentSettings} from '../../domain/ports/ui/payment-settings.port';

@Injectable({providedIn: 'root'})
export class PaymentSettingsHandler implements PaymentSettings {
  private readonly featureFlagService = inject(FEATURE_FLAG_SERVICE);
  private readonly destroyRef = inject(DestroyRef);

  readonly isFastCashPaymentEnabled = signal(false);

  constructor() {
    this.featureFlagService.onFeatureFlagsLoaded$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.isFastCashPaymentEnabled.set(
          this.featureFlagService.isFlagActivated(PaymentFlag.ALLOW_FAST_CASH_PAYMENT)
        );
      });
  }
}
